import * as yup from "yup";

function equalTo(ref, msg) {
  return yup.mixed().test({
    name: 'equalTo',
    exclusive: false,
    message: msg,
    params: {
      reference: ref.path
    },
    test: function(value) {
      return value === this.resolve(ref);
    }
  });
}
yup.addMethod(yup.string, 'equalTo', equalTo);

export const accountLoginFormSchema = yup.object({
  email: yup.string().email('Λάθος διεύθυνση email').required('Απαιτείται'),
  password: yup.string()
    .required('Απαιτείται')
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      "8 Χαρακτήρες, 1 κεφαλαίο, 1 μικρό, 1 αριθμό κι 1 ειδικό χαραχτήρα"
    )
});
